<template>
  <header>
    <img src="https://brownrock.s3.us-east-1.amazonaws.com/Brown-Rock-Logo.png" /><br/>
    <navigation-control />
  </header>
  <router-view/>
</template>

<script>
import { socket } from '@/com/system/socket'
import NavigationControl from './components/controls/NavigationControl.vue'

export default {
  components: { NavigationControl },
  async mounted () {

    socket.emit('join room',{ room: 'brownrock', user: 'bradmin'}, 
      (e) => {
        if(e)
          console.log(e)
      }
    ),
    socket.emit('broadcastToChannel', {room: 'brownrock',data: 'payload'}),

    socket.on('beacon', (data) => { 
      let time = new Date (data.current)
      let seconds = time.getSeconds()+1
      //console.log(seconds)
      this.setSysClock(time)
      
      if(seconds % 5 === 0) {
        this.jobCheck()
      }
      /*
      if(seconds % 15 === 0) {
        console.log('15')
      }
      */
    })

    socket.on('toroom', (data) => { 
      console.log(data)
    })
  }
  
}
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  margin: 0;
  padding: 0;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

header > img {
  height: 60px;
}

</style>
